import React from 'react'

function Indicator() {
  return (
    <div class="text-center">
  <div class="spinner-border" role="status">
    
    
  </div>
</div>
  )
}

export default Indicator